"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const victory_1 = require("victory");
const colors_1 = require("../colors");
const plot_1 = require("../plot");
const layout_1 = require("../../layout");
const styled_1 = require("../../styled");
const akColors = __importStar(require("@atlaskit/theme/colors"));
const theme_1 = require("../../theme");
const CenteredDiv = styled_components_1.default.div `
  text-align: center;
  display: flex;
  justify-content: center;
  height: 200px;
  align-content: center;
  align-items: center;
`;
const TotalTitleFont = styled_components_1.default.div `
  font-family: ${plot_1.FONT_FAMILY};
  font-size: 18px;
  font-weight: 300;
`;
const TotalNumberFont = styled_components_1.default.div `
  font-family: ${plot_1.FONT_FAMILY};
  font-size: 25px;
  font-weight: 300;
`;
const defaultRadius = 150;
const hoveredRadius = defaultRadius + 15;
const hoveredLabelRadius = hoveredRadius + 20;
class DonutChart extends React.Component {
    constructor() {
        super(...arguments);
        this.yTotal = () => this.props.data.map(datum => datum.y).reduce((a, b) => a + b, 0);
    }
    render() {
        const { data, innerRadius, width, height, showAllLabels, setLabel, onClick, centerComponent, title } = this.props;
        return (React.createElement(theme_1.ThemeContextConsumer, null, ({ mode }) => (React.createElement(layout_1.Card, null,
            React.createElement(styled_1.TextAlignCenterDiv, null,
                React.createElement("h4", null, title)),
            React.createElement(victory_1.VictoryContainer, { height: height, width: width },
                React.createElement("svg", null,
                    React.createElement("foreignObject", { x: "25%", y: "25%", width: width / 2, height: height / 2 },
                        React.createElement(CenteredDiv, null, centerComponent || (React.createElement("div", null,
                            React.createElement(TotalTitleFont, null, "TOTAL"),
                            React.createElement(TotalNumberFont, null, this.yTotal()))))),
                    React.createElement(victory_1.VictoryPie, Object.assign({}, this.props, { style: {
                            labels: {
                                fontFamily: plot_1.FONT_FAMILY,
                                fill: mode === "light" ? akColors.N800 : akColors.DN800
                            }
                        }, standalone: false, data: data, colorScale: data.map((datum, index) => datum.color ? datum.color : colors_1.colors[index % colors_1.colors.length]), innerRadius: innerRadius, labels: ({ datum }) => showAllLabels ? setLabel({ datum }) : "", labelRadius: showAllLabels ? undefined : hoveredLabelRadius, events: [
                            {
                                target: "data",
                                eventHandlers: {
                                    onClick: () => [
                                        {
                                            target: "data",
                                            mutation: (datum) => {
                                                if (onClick) {
                                                    onClick(datum.datum);
                                                }
                                                return {
                                                    radius: datum.radius,
                                                    style: datum.style
                                                };
                                            }
                                        }
                                    ],
                                    onMouseOver: () => showAllLabels
                                        ? []
                                        : [
                                            {
                                                target: "labels",
                                                mutation: (datum) => ({
                                                    text: setLabel(datum)
                                                })
                                            },
                                            {
                                                target: "data",
                                                mutation: (datum) => ({
                                                    radius: hoveredRadius,
                                                    style: Object.assign(Object.assign({}, datum.style), { stroke: "black" })
                                                })
                                            }
                                        ],
                                    onMouseLeave: () => showAllLabels
                                        ? []
                                        : [
                                            {
                                                target: "labels",
                                                mutation: () => ({ text: "" })
                                            },
                                            {
                                                target: "data",
                                                mutation: () => ({
                                                    radius: defaultRadius
                                                })
                                            }
                                        ]
                                }
                            }
                        ] }))))))));
    }
}
exports.DonutChart = DonutChart;
DonutChart.defaultProps = {
    showAllLabels: true,
    innerRadius: 90,
    width: 500,
    height: 400,
    setLabel: ({ datum }) => datum.x
};
